var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-edition',{staticClass:"action-set-edition",attrs:{"value-format":"id","multiple":false,"value":_vm.edition_id,"required":true,"clearable":false},on:{"select":_vm.setEdition}})}
var staticRenderFns = []

export { render, staticRenderFns }